import _ from 'lodash'
import { DetailPageTitle, DetailPageTitleWithTag } from './styled'
import { AntTag } from '@agro-club/agroclub-shared'
import { FC } from 'react'
import { Deal } from 'modules/domain/deal/types'
import { useTranslation } from 'react-i18next'
import { DealStatusLabel } from './DealStatusLabel'
import { isDealClosed } from 'modules/domain/deal/utils'
import { PositionTag } from './DealTags/PositionTag'
import { DaysSinceStatusChangeTag } from './DealTags/DaysSinceStatusChangeTag'

interface Props {
  deal: Deal
}

export const DealHeaderTags: FC<Props> = ({ deal }) => {
  const { t } = useTranslation('deal')

  return (
    <DetailPageTitleWithTag>
      <DetailPageTitle>
        {deal?.product.title || ''}
        {deal.season && `, ${deal.season.name}`}
      </DetailPageTitle>
      {isDealClosed(deal) && (
        <AntTag color="grey">{`${t('isClosed')} / ${t(`closed_reasons.${deal.closed_reason}`)}`}</AntTag>
      )}
      <DaysSinceStatusChangeTag deal={deal} />
      <DealStatusLabel status={deal.status} />
      <PositionTag deal={deal} />
    </DetailPageTitleWithTag>
  )
}
